"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var makeListLayoutStyling = function () {
    return {
        container: (0, react_1.css)({
            '&.MuiGrid-container.MuiGrid-spacing-xs-1': {
                width: '100%',
                margin: '-4px auto',
                maxWidth: 668,
            },
        }),
        item: (0, react_1.css)({
            '&.MuiGrid-item': {
                padding: '0 0 12px 0',
            },
        }),
    };
};
exports.default = makeListLayoutStyling;
//# sourceMappingURL=makeListLayoutStyling.js.map